import { Badge } from '@/components/ui/badge';
import { getPersonFirstNameWithLastNameInitial } from '@airreading/common';
import { UserLike } from '@airreading/common/data';
import clsx from 'clsx';

export interface UserIdentifiable {
  id: string;
  user: UserLike;
}

export interface PeopleBadgeListProps {
  people: (UserIdentifiable | UserLike)[];
  wrap?: boolean;
  useFirstNameWithLastNameInitial?: boolean;
  horizontal?: boolean;
}

export function PeopleBadgeList({
  people,
  wrap = false,
  useFirstNameWithLastNameInitial = false,
  horizontal = false,
}: PeopleBadgeListProps) {
  return (
    <div className={clsx(['flex', 'gap-1', horizontal ? 'flex-row' : wrap ? 'flex-wrap' : 'flex-col'])}>
      {people.map((person) => {
        const personObject = 'user' in person ? person.user : person;

        return (
          <Badge
            variant="outline"
            className={clsx(['text-left rounded-sm px-1', horizontal ? 'w-auto' : 'w-fit'])}
            key={person.id}
          >
            {useFirstNameWithLastNameInitial
              ? getPersonFirstNameWithLastNameInitial(personObject)
              : personObject.fullNameOrEmail}
          </Badge>
        );
      })}
    </div>
  );
}
